/** Public Pre-Underwriting API — no auth; calls Edge Functions via VITE_SUPABASE_URL. */

const SUPABASE_PROJECT_URL =
  import.meta.env.VITE_SUPABASE_URL || 'https://ogxgxzvxbmnszfxbiuai.supabase.co';

export const PREUW_FUNCTIONS_BASE = `${SUPABASE_PROJECT_URL.replace(/\/$/, '')}/functions/v1`;

async function parseJson(res) {
  return res.json().catch(() => ({}));
}

export async function fetchAgentsForAgency(agencySlug) {
  const params = new URLSearchParams({ agency_slug: agencySlug });
  const res = await fetch(`${PREUW_FUNCTIONS_BASE}/get-preunderwriting-agents?${params}`);
  const data = await parseJson(res);

  if (res.status === 404) {
    return { ok: false, notFound: true, error: data.error || 'Agency not found' };
  }
  if (!res.ok) {
    return { ok: false, notFound: false, error: data.error || 'Failed to load agents' };
  }
  return {
    ok: true,
    agency: data.agency,
    agents: data.agents || [],
  };
}

export async function fetchSingleAgent(agencySlug, agentId) {
  const params = new URLSearchParams({
    agency_slug: agencySlug,
    agent_id: agentId,
  });
  const res = await fetch(`${PREUW_FUNCTIONS_BASE}/get-preunderwriting-agents?${params}`);
  const data = await parseJson(res);

  if (res.status === 404) {
    return { ok: false, notFound: true, error: data.error || 'Not found' };
  }
  if (!res.ok) {
    return { ok: false, notFound: false, error: data.error || 'Failed to load agent' };
  }
  return {
    ok: true,
    agency: data.agency,
    agent: data.agent,
    agents: data.agents || [],
  };
}

export async function submitPreUnderwritingLog(payload) {
  const res = await fetch(`${PREUW_FUNCTIONS_BASE}/submit-preunderwriting-log`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await parseJson(res);
  if (!res.ok) {
    throw new Error(data.error || 'Submission failed');
  }
  return data;
}

export async function savePreUnderwritingDraft(payload) {
  const res = await fetch(`${PREUW_FUNCTIONS_BASE}/save-preunderwriting-draft`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await parseJson(res);
  if (!res.ok) {
    throw new Error(data.error || 'Failed to save draft');
  }
  return data;
}

export async function getPreUnderwritingDraft({ id, agency_slug }) {
  const res = await fetch(`${PREUW_FUNCTIONS_BASE}/get-preunderwriting-draft`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id, agency_slug }),
  });
  const data = await parseJson(res);
  if (res.status === 404) {
    return { ok: false, notFound: true, error: data.error || 'Draft not found' };
  }
  if (!res.ok) {
    return { ok: false, notFound: false, error: data.error || 'Failed to load draft' };
  }
  return { ok: true, draft: data.draft };
}

export async function sendPreUnderwritingLogEmail({ log_id, pdf_base64, pdf_filename }) {
  const res = await fetch(`${PREUW_FUNCTIONS_BASE}/send-preunderwriting-log-email`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ log_id, pdf_base64, pdf_filename }),
  });
  const data = await parseJson(res);
  if (!res.ok) {
    return {
      success: false,
      message: data.message || data.error || 'Failed to send email',
    };
  }
  return { success: data.success !== false, message: data.message };
}
